// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-agent-traveler-search-traveler-profile-search-criteria-form-module__buttonWrapper--DHx5v {
  width: 125px;
  height: 30px;
}

.src-js-agent-traveler-search-traveler-profile-search-criteria-form-module__buttonWrapper--DHx5v:last-child {
  margin-right: 0px;
}

.src-js-agent-traveler-search-traveler-profile-search-criteria-form-module__buttonGroupWrapper--b1Oeo {
  display: flex;
  justify-content: flex-end;
  margin-top: 25px;
  width: 100%;
}

.src-js-agent-traveler-search-traveler-profile-search-criteria-form-module__inputElementWrapper--Q_WVX {
  display: flex;
  flex-direction: column;
  padding-right: 20px;
  flex-grow: 0.2;
}

.src-js-agent-traveler-search-traveler-profile-search-criteria-form-module__inputElementGroupWrapper--B03MQ {
  display: flex;
  flex-wrap: wrap;
}
`, "",{"version":3,"sources":["webpack://./src/js/agent/traveler/search/traveler-profile-search-criteria-form.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB","sourcesContent":[".buttonWrapper {\n  width: 125px;\n  height: 30px;\n}\n\n.buttonWrapper:last-child {\n  margin-right: 0px;\n}\n\n.buttonGroupWrapper {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 25px;\n  width: 100%;\n}\n\n.inputElementWrapper {\n  display: flex;\n  flex-direction: column;\n  padding-right: 20px;\n  flex-grow: 0.2;\n}\n\n.inputElementGroupWrapper {\n  display: flex;\n  flex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonWrapper": `src-js-agent-traveler-search-traveler-profile-search-criteria-form-module__buttonWrapper--DHx5v`,
	"buttonGroupWrapper": `src-js-agent-traveler-search-traveler-profile-search-criteria-form-module__buttonGroupWrapper--b1Oeo`,
	"inputElementWrapper": `src-js-agent-traveler-search-traveler-profile-search-criteria-form-module__inputElementWrapper--Q_WVX`,
	"inputElementGroupWrapper": `src-js-agent-traveler-search-traveler-profile-search-criteria-form-module__inputElementGroupWrapper--B03MQ`
};
export default ___CSS_LOADER_EXPORT___;
